<div class="property-selector-dialog">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Seleccionar propiedad
    </span>
    <span class="dialog-description">
        Por favor seleccione una propiedad de la lista.
    </span>
    <form class="filters" [formGroup]="filtersFG">
        <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
            <mat-label>Dirección</mat-label>
            <input type="text" matInput formControlName="direccion">
            <button matSuffix mat-icon-button type="button" class="clear-filter-button" (click)="filtersFG.controls.direccion.setValue(undefined)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
            <mat-label>Código RE/MAX</mat-label>
            <input type="text" matInput formControlName="codigo">
            <button matSuffix mat-icon-button type="button" class="clear-filter-button" (click)="filtersFG.controls.codigo.setValue(undefined)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="garantor-form-field no-bottom-spacing-form-field" appearance="outline">
            <mat-label>Propietario</mat-label>
            <input type="text" matInput formControlName="propietario" [matAutocomplete]="ownerAutocomplete">
            <mat-autocomplete #ownerAutocomplete="matAutocomplete" [displayWith]="displayOwner" panelWidth="600px">
                <mat-option *ngFor="let owner of owners" [value]="owner">
                    {{ getOwnerName(owner) }} - {{ owner.tipoPersona === 'FISICA' ? owner.personaFisica.dni : owner.personaJuridica.cuit }} - {{ owner.email }}
                </mat-option>
            </mat-autocomplete>
            <button matSuffix mat-icon-button type="button" class="clear-filter-button" (click)="filtersFG.controls.propietario.setValue(undefined)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
        <button mat-raised-button color="primary" type="button" class="garantor-button mini apply-filters-button" (click)="paginatorStatus.itemsPerPage = 50; getProperties()">
            Aplicar filtros
        </button>
    </form>
    <div class="property-list" *ngIf="properties && properties.length">
        <div class="property-card" *ngFor="let property of properties" (click)="cerrarDialogo(property)">
            <div class="left">
                <span class="address">
                    {{ property.direccion.calle }} {{ property.direccion.numero }}
                </span>
                <span class="floor-department">
                    <span class="floor" *ngIf="property.direccion.piso">
                        <b>Piso: </b>{{ property.direccion.piso }}
                    </span>
                    <span class="department" *ngIf="property.direccion.departamento">
                        <b>Dpto: </b>{{ property.direccion.departamento }}
                    </span>
                </span>
                <span class="locality">
                    {{ property.direccion.localidad.descripcion }}, {{ property.direccion.localidad.municipio.descripcion }}, {{ property.direccion.localidad.provincia.descripcion }}
                </span>
            </div>
            <div class="right">
                <span class="code">
                    <b>Código RE/MAX: </b>{{ property.codigo }}
                </span>
            </div>
        </div>
        <button mat-raised-button color="primary" type="button" class="garantor-button mini load-all-button" (click)="paginatorStatus.itemsPerPage = 100000; getProperties()" *ngIf="paginatorStatus.totalElementCount > 30 && paginatorStatus.itemsPerPage === 30">
            Cargar todas
        </button>
    </div>
    <div class="empty" *ngIf="properties && !properties.length">
        No se encontraron propiedades.
    </div>
</div>
